<script>
  import resources from './resources'
  export default {
    name: 'overview',
    mixins: [resources]
  }
</script>

<template lang="pug">
  div
    .body.m-b-5.b-green(v-for="schedule in schedules")
      .event-name.row
        .col-3.text-center
          h4
            | {{ dtDay(schedule.start_date) }}
            span {{ dtMonth(schedule.start_date) }}
            span {{ dtYear(schedule.start_date)}}
        .col-9
          h6 {{ schedule.event_name }}
          p {{ schedule.title }}
          address
            i.zmdi.zmdi-pin
            |  {{ schedule.area.name }}
</template>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/afters/after.vue